var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:_vm.dynamicClass,on:{"click":_vm.exec}},[(_vm.icon)?_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon,"size":"xs"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.caption)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }